module.exports = __webpack_public_path__ + "img/jumeirah.2079d6e.svg";